import { t } from '../../engine/i18n/i18n';

/**
 * Shared march-duration formatting. Lives in its own module because both the
 * Send Army modal and the Battle history screen render march times, and they
 * previously carried two separate copies of this function — neither of which
 * had an hours branch, so a cross-map siege march rendered as "1057m".
 *
 * Deliberately NOT the same as colony-screen.ts's `formatDuration`, which
 * rounds to whole minutes for build timers: march times need seconds precision
 * at the short end ("4m 12s") and hours at the long end ("17h 37m").
 */
export function formatMarchTime(totalSeconds: number): string {
  const seconds = Math.max(0, Math.round(totalSeconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const rem = seconds % 60;

  if (hours > 0) {
    // Seconds are noise at this scale — nobody plans a 17-hour march to the second.
    return minutes === 0 ? t('battle.march.h', { h: hours }) : t('battle.march.hm', { h: hours, m: minutes });
  }
  if (minutes === 0) return t('battle.march.s', { s: rem });
  return rem === 0 ? t('battle.march.m', { m: minutes }) : t('battle.march.ms', { m: minutes, s: rem });
}
